import { motion } from "framer-motion";
import { ShieldCheck, FileText, Globe2, Lock, ScrollText } from "lucide-react";
import { TEST_IDS } from "@/constants/testIds";
import { useT } from "@/i18n/LanguageContext";

const icons = [ShieldCheck, FileText, Globe2, Lock, ScrollText];
const romans = ["I", "II", "III", "IV", "V"];

export const Certification = () => {
  const { t } = useT();
  const highlights = t("certification.highlights");

  return (
    <section
      id="trust"
      data-testid={TEST_IDS.certification.root}
      className="relative py-28 md:py-40 bg-soft"
    >
      <div className="container-luxe">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-6"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-[11px] tracking-[0.4em] text-gold">
                {t("certification.index")}
              </span>
              <div className="h-px w-12 bg-gold" />
              <span className="overline">{t("certification.overline")}</span>
            </div>
            <h2
              data-testid={TEST_IDS.certification.heading}
              className="h-display text-4xl md:text-5xl lg:text-6xl text-ink text-balance"
            >
              {t("certification.title1")}
              <br />
              <span className="italic">{t("certification.title2")}</span>
            </h2>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-ink/85 font-light">
              {t("certification.body")}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
            className="lg:col-span-6"
          >
            <ul className="border-t border-ink/15">
              {highlights.map((text, i) => {
                const Icon = icons[i];
                return (
                  <li
                    key={text}
                    className="group flex items-center gap-6 py-6 border-b border-ink/15 hover:border-gold/60 transition-colors duration-500"
                  >
                    <span className="font-display italic text-2xl text-gold w-10">
                      {romans[i]}
                    </span>
                    <div className="w-11 h-11 flex items-center justify-center border border-ink/15 group-hover:border-gold transition-colors duration-500">
                      <Icon
                        className="w-4 h-4 text-ink group-hover:text-gold transition-colors duration-500"
                        strokeWidth={1.3}
                      />
                    </div>
                    <span className="font-display text-lg md:text-xl text-ink/90">
                      {text}
                    </span>
                  </li>
                );
              })}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
